import { render, staticRenderFns } from "./Pespectiva.vue?vue&type=template&id=102ea61d"
import script from "./Pespectiva.vue?vue&type=script&lang=js"
export * from "./Pespectiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports